import { StyledSidebarTitle } from './styled-sidebar-title';

export const SidebarSectionTitle = ({
  children,
  isSidebarOpen,
}: React.PropsWithChildren<{ isSidebarOpen: boolean }>) => {
  return <StyledSidebarTitle folded={!isSidebarOpen}>{children}</StyledSidebarTitle>;
};
